export const INLINE_APP_TOOLS = new Set(['show_file_tree']);

export const isInlineApp = (element: unknown): boolean =>
    INLINE_APP_TOOLS.has((element as any)?.props?.toolName);
